import { Route, Switch } from 'react-router-dom';

import SignupPage from './components/signup/SignupPage';
import ResetPage from './components/reset/ResetPage';
import LoginPage from './components/login/LoginPage';
import Redirect from './components/Redirect';
import GroupsPage from './components/groups/GroupsPage';
import GroupPage from './components/group/GroupPage';
import AllUsersPage from './components/users/AllUsersPage';

import Home from './views/Home';

import Projects from './views/Projects';
import Project from './components/projects/project/Project';

import Competences from './views/Competences';
import Competence from './components/competences/competence/Competence';

import Statistics from './views/Statistics';

import Settings from './views/Settings';

import AuthRoute from 'components/AuthRoute';
import OfficeShow from 'views/OfficeShow';
import Users from 'views/Users';
import UserLayout from 'components/UserLayout';

export default () => {

  return (
    <Switch>
      <Route path="/login" exact component={LoginPage} />
      <Route path="/signup/:id" exact component={SignupPage} />
      <Route path="/reset/:resetHash" exact component={ResetPage} />

      <UserLayout>
        <Switch>
          <AuthRoute path="/home" exact render={() => <Home />} />
          <AuthRoute path="/statistics" exact render={() => <Statistics />} />
          <AuthRoute path="/users" exact admin render={() => <Users />} />
          <AuthRoute path="/settings" exact render={() => <Settings />} />

          <AuthRoute path="/groups" exact admin companyAdmin render={() => <GroupsPage />} />
          <AuthRoute path="/groups/:id" exact admin companyAdmin render={() => <GroupPage />} />
          <AuthRoute path="/users/all" exact admin companyAdmin render={() => <AllUsersPage />} />

          <AuthRoute path="/offices/:id" exact admin companyAdmin render={() => <OfficeShow />} />

          <AuthRoute path="/projects" exact render={() => <Projects />} />
          <AuthRoute path="/projects/:id/:view?" exact render={() => <Project />} />

          <AuthRoute path="/competences" exact render={() => <Competences />} />
          <AuthRoute path="/competences/:id/:view?" exact render={() => <Competence />} />

          <Route path="*" component={Redirect} />
        </Switch>
      </UserLayout>
    </Switch>
  )
};
